import React, { useState, useEffect } from "react";
import { Popover, Steps, Typography, Button, Spin } from "antd";
import {
    InfoCircleOutlined,
} from "@ant-design/icons";
import _NewapplicationService from "../../modules/NewapplicationService";
import { useHistory } from "react-router-dom";
import { ApplicationScreens } from "../../constants/DataConstants";

const { Step } = Steps;
const { Text } = Typography;

const ApplicationWorkFlow = ({ activeKey, applicationStatusSteps }) => {

    const history = useHistory();
    const [loading] = useState(false);
    const [filteredScreens, setFilteredScreens] = useState([]);
    const applicationTypeId = Number(localStorage.getItem("applicationTypeId"));

    const getFilteredScreens = (applicationTypeId) => {
        switch (applicationTypeId) {
            case 1: // Borrower
                return [
                    "Personal Details",
                    "Identification Details",
                    "Document Upload",
                    "Income Source",
                    "Expenses",
                    "Balance Sheet Asset",
                    "Balance Sheet Total Asset",
                    "Balance Sheet Total Liability",
                    "Questionnaire"
                ];
            case 4: // Borrower & Co-Borrower
                return [
                    "Personal Details",
                    "Identification Details",
                    "Cob Details",
                    "Cob Identification",
                    "Document Upload",
                    "Income Source",
                    "Expenses",
                    "Balance Sheet Asset",
                    "Balance Sheet Total Asset",
                    "Balance Sheet Total Liability",
                    "Questionnaire"
                ];
            case 3: // Borrower & Co-Borrower (Trust)
                return [
                    "Personal Details",
                    "Proof Of Trust",
                    "Identification Details",
                    "Document Upload",
                    "Income Source",
                    "Expenses",
                    "Balance Sheet Asset",
                    "Balance Sheet Total Asset",
                    "Balance Sheet Total Liability",
                    "Questionnaire"
                ];
            case 2: // Trust
                return [
                    "Personal Details",
                    "Proof Of Trust",
                    "Document Upload",
                    "Income Source",
                    "Expenses",
                    "Balance Sheet Asset",
                    "Balance Sheet Total Asset",
                    "Balance Sheet Total Liability",
                    "Questionnaire"
                ];
            default:
                return [];
        }
    };
    useEffect(() => {
        const allowedScreens = getFilteredScreens(applicationTypeId);
        const filtered = ApplicationScreens.filter((screen) =>
            allowedScreens.includes(screen.screenName)
        );
        setFilteredScreens(filtered);
    }, [applicationTypeId]);

    const handleStepClick = (url) => {
        if (url) {
            history.push({
                pathname: url,
                state: { applicationObjId: localStorage.getItem("ApplicationObjId"), isFromDashboard: true, activeKey },
            });
        }
    };


    const content = (
        <Spin spinning={loading}>
            <div
                style={{padding: 15, overflow: "auto" }}
                className="applicationWorkFlow"
            >
                {/** ✅ Compute only ONCE, before mapping */}
                {(() => {
                    const firstIncompleteIndex = filteredScreens.findIndex(
                        s => applicationStatusSteps?.applicationScreenStatus?.[s.statusKey] !== true
                    );
                    const allCompleted = firstIncompleteIndex === -1;

                    return (
                        <Steps
                            size="small"
                            direction="horizontal"
                            labelPlacement="vertical"
                            current={-1}
                            style={{ minWidth: "100%" }}
                        >
                            {filteredScreens.map((screen, index) => {
                                const isCompleted = applicationStatusSteps?.applicationScreenStatus?.[screen.statusKey] === true;

                                const isClickable = allCompleted || index <= firstIncompleteIndex;
                                const isDisabled = !isClickable;

                                let stepColor = "#999"; // in-progress
                                if (isCompleted) stepColor = "#00E3C4"; // completed
                                if (isDisabled) stepColor = "#ccc"; // disabled

                                return (
                                    <Step
                                        key={index}
                                        title={
                                            <div
                                                style={{
                                                    cursor: isClickable ? "pointer" : "not-allowed",
                                                    pointerEvents: isClickable ? "auto" : "none",
                                                    opacity: isDisabled ? 0.5 : 1
                                                }}
                                                onClick={() => {
                                                    if (isClickable) {
                                                        handleStepClick(screen.url);
                                                    }
                                                }}
                                            >
                                                <Text strong style={{ color: stepColor }}>
                                                    {screen.screenName}
                                                </Text>
                                            </div>
                                        }
                                        description={
                                            <Text type="secondary" style={{ color: isDisabled ? "#ccc" : undefined }}>
                                                {screen.date}
                                            </Text>
                                        }
                                        status={isCompleted ? "finish" : "wait"}
                                    />
                                );
                            })}
                        </Steps>
                    );
                })()}
            </div>
        </Spin>
    );

    return (
        <div style={{ textAlign: "right" }}>
            <Popover
                content={content}
                title={
                    <span className="f16" style={{ fontWeight: 600 }}>Application Workflow</span>
                }
                trigger="click"
                placement="bottom"
            >
                <Button icon={<InfoCircleOutlined />} type="link">
                    Application Workflow
                </Button>
            </Popover>
        </div>
    );
};

export default ApplicationWorkFlow;